import { panelSnapshotPosts } from './PanelSnapshotPosts';

const cinematicSnapshot = {
    id: 'cGFuZWw6NWQ4ZDBhNTY0MDRhZmE3MGFjMWRiZDIz',
    partnerId: 349,
    clientId: 7101,
    name: 'Cinematic',
    description: '',
    publishTier: null,
    theme: {
        typography: {
            color: '',
            size: null,
            sizeLiteral: null,
            primary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
            secondary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
        },
        background: {
            url: '',
            size: '',
            repeat: '',
            color: '',
            position: '',
        },
        colorPalette: {
            type: '',
            solid: '',
            highlight: null,
            monochrome: {
                startColor: '',
                endOffset: null,
            },
            colorBlend: {
                startColor: '',
                endColor: '',
            },
            ranked: {
                colors: null,
                contrast: null,
            },
        },
    },
    storyboard: {
        id: 'c3Rvcnlib2FyZDo1ZDhhOTIzODM1YmYyNzA5MDNiYzA0YzM=',
        name: 'legz - panel snapshots',
        pageNumber: {
            enabled: false,
            color: 'white',
            size: 10,
            alignment: 'right',
            showTotal: null,
        },
        watermark: {
            panelIndex: null,
            watermarkRendered: null,
            imageUrl: null,
        },
    },
    scene: {
        id: 'c2NlbmU6NWQ4ZDBhNTY0MDRhZmE3MGFjMWRiZDIy',
        name: 'Scene 21',
        duration: 0,
        disabled: false,
        theme: null,
        sceneTransition: null,
    },
    widget: {
        children: [
            {
                children: null,
                id: '1',
                name: 'cinematic',
                type: 'postsCinematic',
                css: null,
                js: null,
                options: {
                    player: {
                        playing: false,
                        duration: 8,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'ken_burns',
                    animationEnabled: false,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: true,
                    classOverrides: {
                        postInner: {
                            default: 'between',
                        },
                        userGroup: {
                            hasMedia: 'no-grow middle p-reset pt-3 pb-1 pr-3 pl-3',
                            noMedia: 'no-grow middle p-reset pt-3 pb-1 pr-3 pl-3',
                            review: 'no-grow f-reset-center p-0 p-reset vertical',
                        },
                        postText: {
                            hasMedia: 'p-reset pb-3 pr-3 pl-3 pt-1',
                            noMedia: 'p-reset pb-3 pr-3 pl-3 pt-1 ta-c',
                            review: 'p-reset pr-3 pl-3 pt-2 ta-c h-100',
                        },
                        lineClampVerticalAlign: {
                            hasMedia: 'bottom',
                            noMedia: 'middle',
                        },
                        metaGroup: {
                            hasMedia: 'pr-3 pl-3 pt-3 pb-0',
                            noMedia: 'pr-3 pl-3 pt-1 pb-2',
                        },
                        reviewTitle: {
                            default: 'flex center ta-c f-ng-reset mt-2 bottom h-33',
                        },
                        reviewRating: {
                            default: 'flex center no-grow',
                        },
                        reviewDomain: {
                            default: 'flex left no-grow',
                        },
                        reviewProductTitle: {
                            default: 'center',
                        },
                    },
                    postVersion: 2,
                    zeroFill: false,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    showImageStyles: true,
                    imageFilterBlur: false,
                    imageFilterBrightness: false,
                    imageFilterContrast: false,
                    imageFilterGrayscale: false,
                    imageFilterSaturate: false,
                    imageFilterHueRotate: false,
                    imageFilterOpacity: false,
                    imageFilterInvert: false,
                    imageFilterSepia: false,
                    imageFilterBlurValue: 0,
                    imageFilterBrightnessValue: 100,
                    imageFilterContrastValue: 100,
                    imageFilterGrayscaleValue: 0,
                    imageFilterSaturateValue: 100,
                    imageFilterHueRotateValue: 0,
                    imageFilterOpacityValue: 100,
                    imageFilterInvertValue: 0,
                    imageFilterSepiaValue: 0,
                    imageBlendMode: null,
                    imageSecondaryBlendMode: 'normal',
                    imageBlendColor: 'rgba(0,0,0,.0)',
                    imageSecondaryBlendColor: '',
                    presetImageFilters: '',
                    postImageTextSize: 20,
                    postImageTextFormat: 'clamp',
                    postImageTeleprompterSpeed: 50,
                    showReplyLabels: true,
                    showReplyLabelsSize: 20,
                    showReplyBorder: true,
                    replyBorderColor: 'rgba(255,255,255,0.5)',
                    imagePostLineClamp: true,
                    imagePostLineClampValue: 5,
                    imageTextColor: '',
                    imageBackgroundSize: 'cover',
                    imagePostHideText: false,
                    imageFaceDetection: false,
                    showEngagementMetrics: true,
                    engagementMetricsSize: 30,
                    engagementMetricsPosition: 'bottom_left',
                    showTextStyles: true,
                    textOnlyColor: '',
                    textOnlyTextFormat: 'clamp',
                    textOnlyTeleprompterSpeed: 50,
                    showUserGroup: true,
                    postLineClamp: true,
                    postLineClampValue: 6,
                    hashtagTextColor: '',
                    hashtagBackgroundColor: '',
                    mentionTextColor: '',
                    mentionBackgroundColor: '',
                    urlTextColor: '',
                    urlBackgroundColor: '',
                    showTextEntityUrls: false,
                    showUserAvatar: true,
                    showUserName: true,
                    showUserScreenName: true,
                    userGroupIconSize: 20,
                    postTextOnlySize: 35,
                    userGroupAvatarSize: 30,
                    userGroupNameSize: 25,
                    userGroupScreenNameSize: 15,
                    userGroupPosition: 'top',
                    userGroupLayoutType: 'a',
                    showIconInUserGroup: true,
                    socialIconBgColor: false,
                    socialIconPosition: {
                        x: 'left',
                        y: 'top',
                    },
                    showText: true,
                    showTimeStamp: false,
                    timeStampSize: 20,
                    timeStampFormat: 'timeAgo',
                    endianTime: 'D MMM YYYY, h:mm a',
                    textFitMin: 20,
                    activePostsInWindow: 1,
                    stripLinks: true,
                    postLayoutOrientation: 'vertical',
                    postCompositionType: 'a',
                    blastDelimiter: 'words',
                    metaThemePalette: [],
                    showSecondaryImageOverlay: false,
                    showZeroEngagementValues: false,
                    metaOffsetTotal: 8,
                    themeOffsetTotal: 2,
                    imageFiltersOpen: true,
                    customFields: {
                        fieldId: '',
                        size: 12,
                    },
                    reviews: {
                        enabled: false,
                        title: {
                            enabled: true,
                            color: '',
                            size: 35,
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 3,
                                },
                                fit: {
                                    min: 20,
                                    max: 400,
                                },
                            },
                        },
                        rating: {
                            enabled: true,
                            filledColor: '',
                            emptyColor: '',
                            size: 35,
                        },
                        product: {
                            enabled: true,
                            color: '',
                            size: 15,
                        },
                        message: {
                            enabled: true,
                            size: 20,
                            color: '',
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 5,
                                },
                                fit: {
                                    min: 20,
                                    max: 400,
                                },
                            },
                        },
                        domain: {
                            enabled: true,
                            color: '',
                            size: 20,
                        },
                    },
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    postComposition: 'a',
                    useLegacyAnimations: false,
                    secondaryOverlayColor: 'rgba(0,0,0,.5)',
                    textOnlyBackgroundColor: '',
                    showPostTextOverlay: true,
                    maxCharacters: 400,
                    postTextClasses: 'bottom',
                    smartSizeCompositions: {
                        baseline: {
                            postTextOnlySize: 35,
                            postImageTextSize: 20,
                            userGroupNameSize: 25,
                            userGroupScreenNameSize: 15,
                            userGroupAvatarSize: 30,
                            userGroupIconSize: 20,
                            engagementMetricsSize: 30,
                        },
                        optionDefaults: {
                            showUserGroup: true,
                            showEngagementMetrics: true,
                            imagePostHideText: false,
                            classOverrides: {
                                postInner: {
                                    default: 'between',
                                },
                                userGroup: {
                                    hasMedia: 'no-grow middle p-reset pt-3 pb-1 pr-3 pl-3',
                                    noMedia: 'no-grow middle p-reset pt-3 pb-1 pr-3 pl-3',
                                    review: 'no-grow f-reset-center p-0 p-reset vertical',
                                },
                                postText: {
                                    hasMedia: 'p-reset pb-3 pr-3 pl-3 pt-1',
                                    noMedia: 'p-reset pb-3 pr-3 pl-3 pt-1 ta-c',
                                    review: 'p-reset pr-3 pl-3 pt-2 ta-c h-100',
                                },
                                lineClampVerticalAlign: {
                                    hasMedia: 'bottom',
                                    noMedia: 'middle',
                                },
                                metaGroup: {
                                    hasMedia: 'pr-3 pl-3 pt-3 pb-0',
                                    noMedia: 'pr-3 pl-3 pt-1 pb-2',
                                },
                                reviewTitle: {
                                    default: 'flex center ta-c f-ng-reset mt-2 bottom h-33',
                                },
                                reviewRating: {
                                    default: 'flex center no-grow',
                                },
                                reviewDomain: {
                                    default: 'flex left no-grow',
                                },
                                reviewProductTitle: {
                                    default: 'center',
                                },
                            },
                        },
                        breakpoints: {
                            xs: {
                                options: {
                                    showUserGroup: false,
                                    imagePostHideText: true,
                                    showEngagementMetrics: false,
                                    classOverrides: {
                                        postText: {
                                            default: 'p-reset p-1 ta-c',
                                        },
                                    },
                                },
                            },
                            s: {
                                options: {
                                    classOverrides: {
                                        userGroup: {
                                            hasMedia:
                                                'no-grow middle p-reset pt-15 pb-1 pr-15 pl-15',
                                            noMedia:
                                                'no-grow middle p-reset pt-15 pb-1 pr-15 pl-15',
                                            review: 'no-grow f-reset-center p-0 p-reset vertical',
                                        },
                                        postText: {
                                            hasMedia: 'p-reset pb-15 pr-15 pl-15 pt-1',
                                            noMedia: 'p-reset pb-15 pr-15 pl-15 pt-1 ta-c',
                                            review: 'p-reset pr-15 pl-15 pt-15 ta-c h-100',
                                        },
                                        lineClampVerticalAlign: {
                                            hasMedia: 'bottom',
                                            noMedia: 'middle',
                                        },
                                        metaGroup: {
                                            hasMedia: 'pr-15 pl-15 pt-15 pb-0',
                                            noMedia: 'pr-15 pl-15 pt-1 pb-15',
                                        },
                                    },
                                },
                            },
                            m: {
                                options: {
                                    classOverrides: {
                                        userGroup: {
                                            hasMedia: 'no-grow middle p-reset pt-2 pb-1 pr-2 pl-2',
                                            noMedia: 'no-grow middle p-reset pt-2 pb-1 pr-2 pl-2',
                                            review: 'no-grow f-reset-center p-0 p-reset vertical',
                                        },
                                        postText: {
                                            hasMedia: 'p-reset pb-2 pr-2 pl-2 pt-1',
                                            noMedia: 'p-reset pb-2 pr-2 pl-2 pt-1 ta-c',
                                            review: 'p-reset pr-2 pl-2 pt-2 ta-c h-100',
                                        },
                                        lineClampVerticalAlign: {
                                            hasMedia: 'bottom',
                                            noMedia: 'middle',
                                        },
                                        metaGroup: {
                                            hasMedia: 'pr-2 pl-2 pt-2 pb-0',
                                            noMedia: 'pr-2 pl-2 pt-1 pb-2',
                                        },
                                    },
                                },
                            },
                        },
                    },
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                },
                userAssetContentUrl: null,
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                id: {
                                    source: 'REPORTING',
                                    reportingEngine: 'LISTENING',
                                    report: 'SPRINKSIGHTS',
                                    pageSize: 6,
                                    sorts: [
                                        {
                                            order: 'DESC',
                                            heading: 'REACH_COUNT',
                                        },
                                    ],
                                    includeFaceDetection: false,
                                    timePeriod: {
                                        timeZone: 'America/Los_Angeles',
                                        key: 'last_7_days',
                                        duration: 1,
                                        startTime: 1569481200000,
                                        endTime: 1569567599999,
                                    },
                                    filters: [
                                        {
                                            dimensionName: 'TOPIC_GROUP_IDS',
                                            filterType: 'IN',
                                            values: ['5a00b9e4e4b082264ab84227'],
                                        },
                                    ],
                                    showInReplyToPost: false,
                                    projections: [],
                                    groupBys: [],
                                },
                                options: {
                                    count: 200,
                                    imagePreload: false,
                                    removeDuplicates: true,
                                    includeFaceDetection: false,
                                    shufflePosts: false,
                                },
                                data: [
                                    {
                                        messageType: 2,
                                        accountId: 999998,
                                        snMsgId: '1176537936575258627',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569343477754,
                                        permalink:
                                            'https://twitter.com/show/status/1176537936575258627',
                                        message:
                                            "In honor of Sprinklr's 10th birthday today, I'm also celebrating the 10lbs I lost from riding my bike to work! #sprinklr10 #sprinklrlife #bikelife https://t.co/dKrY1ueh6M https://t.co/yR4b3ShAwt",
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [147, 170],
                                                    url: 'https://t.co/dKrY1ueh6M',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [171, 194],
                                                    url: 'https://t.co/yR4b3ShAwt',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [111, 122],
                                                    hashtag: 'sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [123, 136],
                                                    hashtag: 'sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [137, 146],
                                                    hashtag: 'bikelife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'Austin, TX',
                                            gender: null,
                                            snId: '24314460',
                                            name: 'Jake Trigg',
                                            screenName: 'ATXatLarge',
                                            email: null,
                                            bio:
                                                "Product, Program and Project Manager for high-growth software startups. I'm a click-counter, and focus on empowering others and being of service.",
                                            following: 214,
                                            followers: 85,
                                            favCount: 37,
                                            statusCount: 534,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/ATXatLarge',
                                            profileUrl: null,
                                            profileImgUrl: `https://thumb.sprinklr.com/?d=200x200&url=${encodeURIComponent(
                                                'http://pbs.twimg.com/profile_images/1254840369/ATX_Large-logo_normal.png'
                                            )}`,
                                            createdTime: 1236999001000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5bc4be8ae4b03a19f57fb6bb',
                                            participationIndex: 0,
                                            influencerIndex: 38,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [281513],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Austin, Texas, United States',
                                            lat: 30.26715,
                                            lon: -97.74306,
                                            additional: {
                                                country: 'United States',
                                                state: 'Texas',
                                                code: 'US',
                                                state_code: 'TX',
                                                city: 'Austin',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[0].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 194,
                                            numRetweets: 1,
                                            reachCount: 41730,
                                            numLikes: 17,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 83,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 17,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                ],
                            },
                        ],
                        format: {
                            type: 'window',
                            options: {
                                padding: 1,
                            },
                        },
                        showInReplyToPost: false,
                    },
                ],
                classes: null,
                theme: {
                    colorFont: null,
                    colorPrimary: '',
                    colorSecondary: '#ff6060',
                    colorBackground: '',
                    colorNegative: '',
                    colorPostive: '',
                    ext: {
                        padding: 40,
                        gridLayoutColumns: 5,
                        gridLayoutRows: 5,
                        showGuides: false,
                        colorGrid: 'rgb(55, 55, 65)',
                        showGridLayout: false,
                        snapToGrid: false,
                        gutter: 20,
                    },
                    fontFamilyPrimary: '',
                    fontFamilySecondary: '',
                    fontSizePrimary: '',
                    fontSizeSecondary: null,
                    fontPrimary: null,
                    fontSecondary: null,
                    backgroundImage: {
                        url: '',
                        previewUrl: null,
                        samId: null,
                        name: null,
                        description: null,
                        backgroundRepeat: null,
                        backgroundSize: null,
                    },
                    typography: {
                        color: '',
                        size: null,
                        sizeLiteral: null,
                        primary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                        secondary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                    },
                    background: {
                        url: '',
                        size: '',
                        repeat: '',
                        color: '',
                        position: '',
                    },
                    colorPalette: {
                        type: '',
                        solid: '',
                        highlight: null,
                        monochrome: {
                            startColor: '',
                            endOffset: null,
                        },
                        colorBlend: {
                            startColor: '',
                            endColor: '',
                        },
                        ranked: {
                            colors: null,
                            contrast: null,
                        },
                    },
                },
                position: {
                    left: '0',
                    right: null,
                    top: '0',
                    bottom: null,
                    width: '100%',
                    height: '100%',
                    portrait: null,
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                analyticsRequests: null,
                analyticsResults: null,
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: 'Cinematic',
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: false,
                    size: 20,
                },
            },
        ],
        id: '1',
        name: null,
        type: null,
        css: null,
        js: null,
        options: {
            player: {
                playing: false,
                duration: 15,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: false,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
        },
        userAssetContentUrl: null,
        postRequests: null,
        classes: 'template_cinematic',
        theme: {
            colorFont: null,
            colorPrimary: null,
            colorSecondary: null,
            colorBackground: null,
            colorNegative: null,
            colorPostive: null,
            ext: {
                padding: 0,
                gridLayoutColumns: 5,
                gridLayoutRows: 5,
                showGuides: false,
                colorGrid: 'rgb(55, 55, 65)',
                showGridLayout: false,
                snapToGrid: false,
                gutter: 20,
            },
            fontFamilyPrimary: null,
            fontFamilySecondary: null,
            fontSizePrimary: null,
            fontSizeSecondary: null,
            fontPrimary: null,
            fontSecondary: null,
            backgroundImage: null,
            typography: {
                color: '',
                size: null,
                sizeLiteral: null,
                primary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
                secondary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
            },
            background: {
                url: '',
                size: '',
                repeat: '',
                color: '',
                position: '',
            },
            colorPalette: {
                type: '',
                solid: '',
                highlight: null,
                monochrome: {
                    startColor: '',
                    endOffset: null,
                },
                colorBlend: {
                    startColor: '',
                    endColor: '',
                },
                ranked: {
                    colors: null,
                    contrast: null,
                },
            },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '1920px',
            height: '1080px',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        analyticsRequests: null,
        analyticsResults: null,
        profileRequests: null,
        profileResults: null,
        trendRequests: null,
        label: {
            titleText: 'Header',
            subTitleText: null,
            classes: null,
            overlap: false,
            layout: 'flex no-grow vertical left',
            icon: null,
            enabled: false,
            size: 20,
        },
    },
    screenIndex: 0,
    sceneIndex: 0,
    dataLastModified: 1569524343777,
};
export default cinematicSnapshot;
